<template>
  <CatalogProductListPreload
    v-if="fetchingContent"
  />

  <div
    v-else
    class="products-list"
    :class="listThemeClass"
  >
    <template v-if="count">
      <ProductCard
        v-for="(product, index) in list"
        :key="`${product.uuid}-${product.code}`"
        class="products-list__card"
        :product="product"
        :block="block"
        :is-wishlist-page="isWishlistPage"
        :disable-hover="isWishlistPage"
        :index="index"
        :show-bonuses-pay="showBonusesPay"
        :theme="listTheme"
        img-width="100%"
        img-height="100%"
        :auction="auction"
        @remove-from-wishlist="handleRemoveFromWishlist"
      />
    </template>

    <div v-else class="products-list__none">
      {{ $t('catalog.no_products') }}
    </div>

    <div v-show="fetching" class="products-list__loader z-index__1">
      <BaseLoader />
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  block: string
  showBonusesPay?: boolean
  isWishlistPage?: boolean
  isSearchPage?: boolean
  isCategoryMonitor?: boolean
  auction?: boolean // Change price box view
}
type Emits = {
  (e: 'remove-from-wishlist', code: string): void
}

const props = withDefaults(defineProps<Props>(), {
  showBonusesPay: false,
  isWishlistPage: false,
  isSearchPage: false,
  isCategoryMonitor: false,
  auction: false
})
const emit = defineEmits<Emits>()
const catalogProductsStore = useCatalogProductsStore()

const {
  list,
  fetching,
  count,
  fetchingContent
  // limit
} = storeToRefs(catalogProductsStore)

const isListTheme = computed(() => {
  return props.isSearchPage || props.isCategoryMonitor || props.auction
})

const listThemeClass = computed(
  () => `products-list--${isListTheme.value ? 'list' : 'default'}`
)

const listTheme = computed(
  () => isListTheme.value ? 'list' : 'default'
)

// const showMore = computed(() => {
//   return catalogFiltersStore.showMore
// })
const handleRemoveFromWishlist = (code: string) => {
  emit('remove-from-wishlist', code)
}

// записати позіцію продукта якщо на нього перейдено з каталогу
// const handleGoToProduct = (productIndex: number) => {
//   if (!productIndex || !showMore.value) {
//     return
//   }
//
//   const { path, query } = unref(route)
//   const currentPage = +(query.page || 1)
//   const itemsPerPage = limit.value
//   const totalPages = Math.ceil(list.value.length / itemsPerPage)
//   const targetPage = Math.ceil(productIndex / itemsPerPage)
//   const pageOffset = currentPage - totalPages + targetPage
//   const targetIndex = productIndex - (targetPage - 1) * itemsPerPage
//
//   catalogFiltersStore.setPositionProduct({
//     path,
//     page: pageOffset,
//     index: targetIndex,
//   })
// }

</script>

<style lang="scss">
.products-list {
  $root: &;
  position: relative;
  margin: 0 -0.4rem;
  display: flex;
  flex-wrap: wrap;

  @media only screen and (max-width: 768px) {
    margin-left: -1.6rem;
    width: calc(100% + 3.2rem);
  }

  &--default {
    .products-list__card {
      border: 1px solid $border-color-preload;
      margin-top: -1px;
      margin-left: -1px;

      @media only screen and (min-width: 768px) {
        width: 33.333%;

        &:nth-child(1) {
          border-radius: 4px 0 0 0;
        }
        &:nth-child(3) {
          border-radius: 0 4px 0 0;
        }
        &:nth-child(3n+1) {
          margin-left: 0;
        }

        &:nth-child(-n+3) {
          margin-top: 0;
        }
      }

      @media only screen and (min-width: 1024px) and (max-width: 1170px) {
        width: 50%;


        &:nth-child(3) {
          border-radius: 0;
        }
        &:nth-child(3n+1) {
          margin-left: -1px;
        }

        &:nth-child(-n+3) {
          margin-top: -1px;
        }

        &:nth-child(1) {
          border-radius: 4px 0 0 0;
        }
        &:nth-child(2) {
          border-radius: 0 4px 0 0;
        }
        &:nth-child(2n+1) {
          margin-left: 0;
        }

        &:nth-child(-n+2) {
          margin-top: 0;
        }
      }

      @media only screen and (min-width: 1560px) {
        width: 25%;

        &:nth-child(1) {
          border-radius: 4px 0 0 0;
        }
        &:nth-child(4) {
          border-radius: 0 4px 0 0;
        }
        &:nth-child(4n+1) {
          margin-left: 0;
        }

        &:nth-child(-n+4) {
          margin-top: 0;
        }
      }

      @media only screen and (max-width: 768px) {
        width: 50%;
        margin-left: 0;
        border-left: none;
      }
    }
  }

  &--list {
    .product-grid-wrapper {
      border: 1px solid $border-color-preload;
      margin-top: -1px;
      margin-left: -1px;

      @media only screen and (min-width: 1024px) and (max-width: 1300px) {
        width: 50%;

        &:nth-child(1) {
          border-radius: 4px 0 0 0;
        }
        &:nth-child(2) {
          border-radius: 0 4px 0 0;
        }
        &:nth-child(2n+1) {
          margin-left: 0;
        }

        &:nth-child(-n+2) {
          margin-top: 0;
        }
      }

      @media only screen and (min-width: 1300px) {
        width: 33.333%;

        &:nth-child(1) {
          border-radius: 4px 0 0 0;
        }
        &:nth-child(3) {
          border-radius: 0 4px 0 0;
        }
        &:nth-child(3n+1) {
          margin-left: 0;
        }

        &:nth-child(-n+3) {
          margin-top: 0;
        }
      }

      @media only screen and (min-width: 1560px) {
        width: 25%;

        &:nth-child(1) {
          border-radius: 4px 0 0 0;
        }
        &:nth-child(4) {
          border-radius: 0 4px 0 0;
        }
        &:nth-child(4n+1) {
          margin-left: 0;
        }

        &:nth-child(-n+4) {
          margin-top: 0;
        }
      }

      @media only screen and (max-width: 1024px) {
        width: 100%;
        margin-left: 0;
      }
    }
  }

  &__wrap {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
  }

  &__none {
    margin-left: 1.6rem;
  }

  &__loader {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba($white-color, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
